module.exports = __webpack_public_path__ + "media/ngîan jing jà-ríng.d00cba51.mp3";